import { allEnumValues, FulfillmentMethod, OrderThrottlingCapDuration, OrderThrottlingMethod, Weekday, } from '@biteinc/enums';
export const orderThrottlingRuleSchema = {
    displayName: 'Order Throttling Rule',
    type: 'object',
    fields: {
        _id: {
            isHidden: true,
            type: 'mongoId',
            required: true,
        },
        name: {
            required: true,
            type: 'shortString',
        },
        isEnabled: {
            displayName: 'Enabled',
            type: 'bool',
        },
        orderThrottlingMethod: {
            displayName: 'Throttling Method',
            required: true,
            type: 'stringEnum',
            enum: OrderThrottlingMethod,
            ui: 'dropdown',
        },
        timePeriod: {
            displayName: 'Time Period',
            subtype: 'HourRange',
            type: 'object',
            required: true,
        },
        weekdays: {
            displayName: 'Weekdays',
            type: 'array',
            elementType: 'stringEnum',
            elementEnum: Weekday,
            required: true,
            ui: 'checklist',
            minCount: 1,
        },
        cap: {
            displayName: 'Cap Value',
            type: 'int',
            required: true,
        },
        orderThrottlingCapDuration: {
            displayName: 'Cap Duration',
            type: 'stringEnum',
            enum: OrderThrottlingCapDuration,
            ui: 'radiolist',
            required: true,
        },
        fulfillmentMethods: {
            displayName: 'Apply to Dining Options',
            type: 'array',
            elementType: 'int',
            elementValues: allEnumValues(FulfillmentMethod),
            warningHtml: 'ASAP orders will never be throttled.<br/>Selecting an ASAP dining option here will mean that orders from said dining option will <strong>count towards this throttle rule</strong>.',
            ui: 'checklist',
            required: true,
            minCount: 1,
        },
    },
};
//# sourceMappingURL=order_throttling_rule_schema.js.map